import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description?: string;
  canonicalPath?: string;
}

/**
 * 页面级 SEO 设置：更新 title、meta description 与 canonical。
 * 用于多页 SPA，各页面在挂载时调用以生成独立且符合内容的元信息。
 */
export function useSeo({ title, description, canonicalPath }: SeoProps) {
  useEffect(() => {
    document.title = title;

    if (description) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const origin = window.location.origin;
    const base = __BASE_PATH__ ?? '';
    canonical.setAttribute('href', `${origin}${base}${canonicalPath ?? ''}`);
  }, [title, description, canonicalPath]);
}